<template>
    <div>
        <Register />
    </div>
</template>
<script setup>
import { Link } from '@inertiajs/vue3';
import Register from '@/components/auth/register.vue';
</script>
